import React from 'react';
import { Box, Text, StyledOcticon } from '@primer/components'

import { CommentDiscussion } from '@primer/octicons-react'


export default function() {

  return (
    <Box className="text-white" style={{background: 'linear-gradient(to right, #363795, #005C97)'}}>
      <Box className="container-lg pt-md-8 pb-md-8 pt-4 pb-4">
        <Box alignItems="center" className="text-center mb-4 mb-md-0 col-md-8 offset-md-2">
          <StyledOcticon
            icon={CommentDiscussion}
            size={64}
            marginRight={'6px'}
          />
          <Box>
            <Text as="p" className="f2">"Extremely positive. Suggested useful changes, giving our senior developers time back."</Text>
            <Text className="f3">Jon Atkinson, Technical Director at Giant</Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
